module.exports = __webpack_public_path__ + "static/media/checkstyle05.df686771.png";